// ACTION CREATOR SAVE_FILES_DATA
export const SAVE_FILES_DATA = 'SAVE_FILES_DATA';

// ACTION CREATOR saveFilesData
export const saveFilesData = (value) => ({
  type: SAVE_FILES_DATA,
  value,
});

// ACTION CREATOR SAVE_FILES_GRID
export const SAVE_FILES_GRID = 'SAVE_FILES_GRID';

// ACTION CREATOR saveFilesGrid
export const saveFilesGrid = (value) => ({
  type: SAVE_FILES_GRID,
  value,
});

// ACTION CREATOR SET_OPEN_MODAL
export const SET_OPEN_MODAL = 'SET_OPEN_MODAL';

// ACTION CREATOR setOpenModal
export const setOpenModal = (value) => ({
  type: SET_OPEN_MODAL,
  value,
});

// ACTION CREATOR SET_SAVE_FILES_SELECTED
export const SET_SAVE_FILES_SELECTED = 'SET_SAVE_FILES_SELECTED';

// ACTION CREATOR setSaveFilesSelected
export const setSaveFilesSelected = (value) => ({
  type: SET_SAVE_FILES_SELECTED,
  value,
});

// ACTION CREATOR SET_SAVE_FILES_SELECTED_PAGE_FILE
export const SET_SAVE_FILES_SELECTED_PAGE_FILE = 'SET_SAVE_FILES_SELECTED_PAGE_FILE';

// ACTION CREATOR setSaveFilesSelectedPageFile
export const setSaveFilesSelectedPageFile = (value) => ({
  type: SET_SAVE_FILES_SELECTED_PAGE_FILE,
  value,
});

// ACTION CREATOR SET_MARKER_FILES_STRING
export const SET_MARKER_FILES_STRING = 'SET_MARKER_FILES_STRING';

// ACTION CREATOR setMarkerFilesString
export const setMarkerFilesString = (value) => ({
  type: SET_MARKER_FILES_STRING,
  value,
});

// ACTION CREATOR SET_LOADING_FILES
export const SET_LOADING_FILES = 'SET_LOADING_FILES';

// ACTION CREATOR setLoadingFiles
export const setLoadingFiles = (value) => ({
  type: SET_LOADING_FILES,
  value,
});

// ACTION CREATOR FETCH_COMBINATION_FILES
export const FETCH_COMBINATION_FILES = 'FETCH_COMBINATION_FILES';

// ACTION CREATOR fetchCombinationFiles
export const fetchCombinationFiles = (query, server, glassapi) => ({
  type: FETCH_COMBINATION_FILES,
  query,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_LOCATION_FILE
export const SAVE_LOCATION_FILE = 'SAVE_LOCATION_FILE';

// ACTION CREATOR saveLocationFile
export const saveLocationFile = (value) => ({
  type: SAVE_LOCATION_FILE,
  value,
});

// ACTION CREATOR SET_FILE_CLICKED
export const SET_FILE_CLICKED = 'SET_FILE_CLICKED';

// ACTION CREATOR setFileClicked
export const setFileClicked = (value) => ({
  type: SET_FILE_CLICKED,
  value,
});

// ACTION CREATOR SET_PAGE_VALUE
export const SET_PAGE_VALUE = 'SET_PAGE_VALUE';

// ACTION CREATOR setPageValue
export const setPageValue = (value) => ({
  type: SET_PAGE_VALUE,
  value,
});

// ACTION CREATOR FETCH_FILES_DATA_PAGINATION
export const FETCH_FILES_DATA_PAGINATION = 'FETCH_FILES_DATA_PAGINATION';

// ACTION CREATOR fetchFilesDataPagination
export const fetchFilesDataPagination = (page, query, number, server, glassapi) => ({
  type: FETCH_FILES_DATA_PAGINATION,
  page,
  query,
  number,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_FILES_DATA_PAGINATION
export const SAVE_FILES_DATA_PAGINATION = 'SAVE_FILES_DATA_PAGINATION';

// ACTION CREATOR saveFilesDataPagination
export const saveFilesDataPagination = (value) => ({
  type: SAVE_FILES_DATA_PAGINATION,
  value,
});

// ACTION CREATOR LAUNCH_DATA_PAGINATION
export const LAUNCH_DATA_PAGINATION = 'LAUNCH_DATA_PAGINATION';

// ACTION CREATOR launchDataPagination
export const launchDataPagination = (value) => ({
  type: LAUNCH_DATA_PAGINATION,
  value,
});

// ACTION CREATOR SET_VALUE_DISPLAY_LOADING
export const SET_VALUE_DISPLAY_LOADING = 'SET_VALUE_DISPLAY_LOADING';

// ACTION CREATOR setValueDisplayLoading
export const setValueDisplayLoading = (value) => ({
  type: SET_VALUE_DISPLAY_LOADING,
  value,
});

// ACTION CREATOR SET_SAVE_QUERY_PARAMS
export const SET_SAVE_QUERY_PARAMS = 'SET_SAVE_QUERY_PARAMS';

// ACTION CREATOR setSaveQueryParams
export const setSaveQueryParams = (value) => ({
  type: SET_SAVE_QUERY_PARAMS,
  value,
});
